/**
 * Internal dependencies
 */
import cecSdk from 'lib/customer-ec-sdk';
import * as actions from 'state/action-types';

export default (connectionId = null, saleId = null) => (dispatch) => {
    return cecSdk
        .connection(connectionId)
        .exportSale(saleId)
        .then((response) => {
            return response;
        });
};
